export const MAX_USER_FILE_SIZE = 5 * 1024 * 1024;

export class UserFileSizeLimitError extends Error {
	constructor() {
		super('USER_FILE_SIZE_LIMIT');
		this.name = 'UserFileSizeLimitError';
	}
}

export const assertUserFileSize = (file?: File | null) => {
	if (file && file.size > MAX_USER_FILE_SIZE) {
		throw new UserFileSizeLimitError();
	}
};

export const isUserFileSizeLimitError = (error: unknown) => {
	if (error instanceof UserFileSizeLimitError) {
		return true;
	}

	const response = (error as { response?: { status?: number; data?: { message?: unknown } } })?.response;
	const message = Array.isArray(response?.data?.message)
		? response.data.message.join(' ')
		: String(response?.data?.message || '');

	return (
		response?.status === 413 ||
		/(?:too large|file size|size limit|maximum size|exceed.*size|size.*exceed)/i.test(message)
	);
};
